import React from 'react';

import { MarketManipulationComplexityRatingInfo, ratingToLetter } from 'domain/types';

import { MarketName } from '../MarketName';
import { getRatingLabel, getResistantLabel } from './utils';

export function MarketManipulationComplexityTranscription(
  props: MarketManipulationComplexityRatingInfo,
) {
  const {
    rating: { rating },
    transcription,
  } = props;
  const { marketName, badAssets } = transcription;

  switch (rating) {
    case 0:
    case 1:
      return (
        <>
          <MarketName marketName={marketName} /> market{' '}
          <span>is {getResistantLabel(rating)} to price manipulation attacks</span>
        </>
      );
    case 2:
    case 3:
    case 4:
      return (
        <span>
          {getRatingLabel(rating)} of price manipulation{' '}
          {badAssets.length > 0 ? `for ${badAssets.map(item => item.symbol).join(', ')}` : ''}
        </span>
      );

    default:
      return <span>Unknown rating {ratingToLetter(rating)}</span>;
  }
}
